import {
  Conversation,
  ConversationLogItemMessageAdded,
} from '@stripe-internal/conversations-client';
import {view, css, tokens, useTokenValue} from '@sail/ui';
import {rowForMessage} from './rowForMessage';
import {avatarForMessage} from './avatarForMessage';
import {AvatarSpacer} from '../../../Chat/AvatarSpacer';
import {
  useNewUniversalHelpDesign,
  useUniversalHelpDotComDesign,
} from '../../../FeatureFlagsProvider';

type Props = {
  conversation: Conversation;
  items: ConversationLogItemMessageAdded[];
  disableInteraction?: boolean;
  animated?: boolean;
  className?: string | null;
};

export function GroupedMessagesRow({
  conversation,
  items,
  disableInteraction,
  animated,
  className,
}: Props) {
  const useNewDesign = useNewUniversalHelpDesign();
  const useDotComDesign = useUniversalHelpDotComDesign();

  const xsmallBorder = useTokenValue(tokens.border.radius.xsmall);

  if (items.length === 0) {
    return null;
  }

  const avatar = items.length > 0 ? avatarForMessage(items[0]) : null;
  const spacer = avatar ? <AvatarSpacer /> : null;

  const rows = items.map((item, i) => {
    return rowForMessage({
      conversation,
      item,
      avatar: i === 0 ? avatar : spacer,
      animated,
      disableInteraction,
      disableAvatar: useDotComDesign,
    });
  });

  let gap = 'xsmall';

  if (useNewDesign) {
    gap = 'large';
  } else if (useDotComDesign) {
    gap = 'small';
  }

  return (
    <view.div
      className={`uh-conversations-grouped-messages v1 ${className}`}
      data-testid="grouped-messages-row"
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap,
        flex: 1,
      }}
      uses={[
        css.global({
          '.uh-conversations-new-design .uh-conversations-grouped-messages.v1 .uh-conversations-text-message-row[data-message-type="user"]:last-child .uh-conversations-chat-bubble':
            {borderBottomRightRadius: `${xsmallBorder} !important`},
          '.uh-conversations-new-design .uh-conversations-grouped-messages.v1 .uh-conversations-button-options-message-row[data-message-type="user"]:last-child .uh-conversations-chat-bubble':
            {borderBottomRightRadius: `${xsmallBorder} !important`},
          '.uh-conversations-new-design .uh-conversations-grouped-messages.v1 .uh-conversations-text-message-row[data-message-type="agent"]:last-child .uh-conversations-chat-bubble':
            {borderBottomLeftRadius: `${xsmallBorder} !important`},
        }),
      ]}
    >
      {rows}
    </view.div>
  );
}
